<template>
  <div>
    <div class="paginator-info-bottom mt-2">
      <span class="m--font-gray" v-if="from"
        >Exibindo itens de {{ from }} a {{ to }}, de um total de {{ total }}.</span
      >
      <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
    </div>
    <div class="paginator-list">
      <nav aria-label="...">
        <ul class="pagination pagination-md">
          <li class="page-item" :class="{ disabled: current_page === 1 }">
            <a class="page-link paginate" @click="setPage(1)"
              ><i class="fal fa-angle-double-left"></i
            ></a>
          </li>
          <li class="page-item" :class="{ disabled: current_page === 1 }">
            <a class="page-link paginate" @click="setPage(current_page - 1)"
              ><i class="fal fa-angle-left"></i
            ></a>
          </li>
          <li class="page-item" :class="{ disabled: current_page === 1 }" v-if="current_page > 2">
            <a class="page-link paginate" @click="setPage(current_page - 2)">
              {{ current_page - 2 }}</a
            >
          </li>
          <li class="page-item" :class="{ disabled: current_page === 1 }" v-if="current_page > 1">
            <a class="page-link paginate" @click="setPage(current_page - 1)">
              {{ current_page - 1 }}</a
            >
          </li>
          <li class="page-item selected">
            <a class="page-link paginate"> {{ current_page }} </a>
          </li>
          <li
            class="page-item"
            :class="{ disabled: current_page === last_page }"
            v-if="current_page < last_page"
          >
            <a class="page-link paginate" @click="setPage(current_page + 1)">
              {{ current_page + 1 }}
            </a>
          </li>
          <li
            class="page-item"
            :class="{ disabled: current_page + 1 === last_page }"
            v-if="current_page + 1 < last_page"
          >
            <a class="page-link paginate" @click="setPage(current_page + 2)">
              {{ current_page + 2 }}
            </a>
          </li>
          <li class="page-item" :class="{ disabled: current_page === last_page }">
            <a class="page-link paginate" @click="setPage(current_page + 1)"
              ><i class="fal fa-angle-right"></i
            ></a>
          </li>
          <li class="page-item" :class="{ disabled: current_page === last_page }">
            <a class="page-link paginate" @click="setPage(last_page)"
              ><i class="fal fa-angle-double-right"></i
            ></a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PaginatorBottom',
  data() {
    return {};
  },
  props: {
    from: {
      type: Number,
    },
    to: {
      type: Number,
    },
    total: {
      type: Number,
    },
    current_page: {
      type: Number,
    },
    last_page: {
      type: Number,
    },
  },
  methods: {
    setPage(page) {
      this.$emit('setPage', page);
    },
  },
};
</script>
